import type { JobStatus } from '../api/types';

const JOB_STATUS_COLORS: Record<JobStatus, string> = {
  JOB_START: 'blue',
  PROCESS_STEP_START: 'cyan',
  PROCESS_STEP_END: 'green',
  JOB_END: 'green',
  JOB_END_EXCEPTION: 'red',
};

const JOB_STATUS_LABELS: Partial<Record<JobStatus, string>> = {
  JOB_START: 'Active',
  JOB_END: 'Completed',
  JOB_END_EXCEPTION: 'Failed',
};

export function getJobStatusTagColor(status: string): string {
  return JOB_STATUS_COLORS[status as JobStatus] ?? 'default';
}

export function getJobStatusLabel(status: string): string {
  return JOB_STATUS_LABELS[status as JobStatus] ?? status;
}
